<template>
  <div id="app" v-scrolling="handleScroll">
    <Header
      :Fixed="headerFix"
      v-if="!$route.path.includes('admin')"
    />
      <router-view/>
    <Footer/>
    <Popup
      :Classname="$route.query.Popup+'Class'"
      v-if="$route.query.Popup"
      @outCancel="cancelBack()"
    >
      <template v-slot:product>
          <div class="productImg" v-if="$route.query.Popup=='product'">
            <img :src="popBox.imagePath" :alt="popBox.image" v-if="popBox">
          </div>
          <div class="info" v-if="$route.query.Popup=='product'">
            <div>
              <h2>{{popBox[locales]}}</h2>
              <h5>{{popBox['size'] && $t('Popup.product.size')}} {{popBox['size']}}</h5>
            </div>
            <div class="cursorPoint">
              <div @click="redirectTo(popBox)">{{$t('Popup.product.tell')}}</div>
              <div @click="cancelBack()">{{$t('Popup.product.cancel')}}</div>
            </div>
          </div>
      </template>
      <template v-slot:contact>
        <div v-if="$route.query.Popup=='contact'" :style="{backgroundImage:'url('+Images.Comp.Contact.bg+')'}">
        </div>
        <div v-if="$route.query.Popup=='contact'">
          <h2>{{$t('Popup.contact.titile')}}</h2>
          <form>
            <label for="CompanyName" name="reqLabel">{{$t('Popup.contact.company')}}</label>
            <input id="CompanyName" type="text" :placeholder="$t('Popup.contact.company')" v-model="formModel.name">
            <label for="CompanyMail" name="reqLabel">{{$t('Popup.contact.email')}}</label>
            <input id="CompanyMail" type="email" placeholder="company@example.com" v-model="formModel.mail">
            <label for="Request">{{$t('Popup.contact.msg')}}</label>
            <textarea
            id="Request"
            cols="30" rows="5"
            :placeholder="$t('Popup.contact.placeholder')"
            type="text"
            v-model="formModel.request">
            </textarea>
          </form>
          <div class="button">
            <button class="cursorPoint" @click="sendRequest(formModel)">
              <h5>{{$t('Popup.contact.send')}}</h5>
            </button>
            <button @click="cancelBack" class="cursorPoint">
              <h5>{{$t('Popup.contact.cancel')}}</h5>
            </button>
          </div>
        </div>
      </template>
      <template v-slot:language>
        <ul v-if="$route.query.Popup=='language'" class="LangBox">
          <li class="langbtn">
            <div class="title">
              <h3>{{$t('Popup.language.title')}}</h3>
            </div>
            <div v-for="(L,key) in Lang" :key="key" @click="changeLang(key)" class="cursorPoint" :class="key == LangChose?'actived':''">
              <h5>{{L}}</h5>
            </div>
          </li>
          <li @click="cancelBack(LangChose)" v-if="LangChose != locales" class="savebtn cursorPoint"><h5>{{$t('Popup.language.save')}}</h5></li>
          <li @click="cancelBack()" class="cancelbtn cursorPoint"><h5>{{$t('Popup.language.cancel')}}</h5></li>
        </ul>
      </template>
      <template v-slot:pdf>
        <div v-if="$route.query.Popup=='dm'" class="pdfBar">
            <img :src="Images.Logo.logoWhite" alt="">
            <div>
              <a href="./static/soonport_download.pdf" target="_blank">
              <img :src="Images.Home.Search.download" alt="">
              </a>
              <img :src="Images.Home.Search.cancel" alt="" @click="cancelBack()">
            </div>
        </div>
      </template>
      <template v-slot:category>
        <div v-if="$route.query.Popup=='category'">
          <h2>Change category</h2>
          <div @click="cancelBack()">
            <img :src="Images.Home.Search.cancel" alt="">
          </div>
        </div>
        <ul v-if="$route.query.Popup=='category'">
          <li v-for="(item,key) in CataNowList" :key="key" :class="key==categoryNow?'actived':''" @click="changeCata(item[locales],key)">
            <img :src="item.iconPath" alt="">
            <h4>{{item[locales]}}</h4>
          </li>
        </ul>
      </template>
    </Popup>
    
  </div>
</template>

<script>
  import GMap from '@/components/frontend/GMap.vue'
  import {mapState,mapActions,mapGetters} from "vuex"
  import i18n from './i18n'
  
  // var loadingTask = pdf.createLoadingTask('./static/soonport.pdf');

  export default{
    data(){
      return{
        headerFix:false,
        scrollY:0,
        Lang:{
          'name_EN':'English',
          'name_CH':'中文'
        },
        LangChose:'name_EN',
        formModel:{
          name:'',
          mail:'',
          request:''
        },
        alertMsg:{
          name:false,
          mail:false
        },
      }
    }
    ,components:{
      i18n
    },
    methods:{
      ...mapActions('frontend',[
          'localeChange',
          'fetchProduct',
          'getWindowW',
          'changeCategory',
          'fetchNewsCategories'
        ]),
      ...mapActions('backend', [
          'sendCantactForm'
      ]),
      handleScroll(){
        this.scrollY = window.scrollY
      },
      cancelBack(Lang){
        if(Lang){
          const payload = {LANG:this.LangChose}
          this.localeChange(payload)
          i18n.locale = this.LangChose
          localStorage.Language = this.LangChose
        }else{
          this.LangChose = this.locales
        }
        this.formModel = {}
        this.$router.replace({})
      },
      changeCata(name,id){
				const payload={name:name,id:id}
				this.changeCategory(payload)
        this.cancelBack()
      },
      redirectTo(popBox){
        this.$gtag.event('客戶從產品點擊聯絡', {
          'event_category': this.clientId,
          'event_label': `點擊聯絡按鈕_從${popBox.name_CH}`,
          'value': 200
        })
        this.$router.replace({query:{Popup:'contact'}})
      },
      changeLang(Lang){
        this.LangChose = Lang
      },
      sendRequest: async function(forms) {
        if(forms.name!=''&&forms.mail!=''){
          const response = await this.sendCantactForm({ ...forms });
          if (response) {
            this.$gtag.event('客戶發送訊息', {
              'event_category': this.clientId,
              'event_label': `訊息發送`,
              'value': 200
            })
            this.cancelBack();
            alert('Request Sent');
          }
        }else{
          console.log(Object.entries(this.formModel).filter(arr=>arr[1]=='').reduce((ac,el)=>
          {return [...ac,el[0]]},[]))
        }
      },
      handleResize(){
        this.getWindowW()
      }
    },
    computed:{
      ...mapState('frontend',[
          'products',
          'locales',
          'Images',
          'categoryNow',
          'Videos'
        ]),
        ...mapState('analytic',[
          'clientId',
        ]),
        ...mapGetters('frontend',[
          'CataNowList'
        ]),
      popBox(){
        if(this.$route.query.Popup){
          return this.products.filter(item=>item.id == this.$route.query.id)[0]
        }
      }
    },
    created(){
      this.$store.dispatch('frontend/fetchProduct')
      this.$store.dispatch('frontend/fetchNewsCategories')
    },
    mounted(){
      if(localStorage.Language){
        const LANG = {LANG:localStorage.Language}
        this.localeChange(LANG)
        this.LangChose = localStorage.Language
        i18n.locale = localStorage.Language
      }else{
        localStorage.Language = this.LangChose
        i18n.locale = this.LangChose
      }
      this.getWindowW()
      window.addEventListener('load', () => {
        const clientId = ga.getAll()[0].get('clientId');
        this.$store.dispatch('analytic/saveClientId', clientId);
      })
      window.addEventListener('resize',this.handleResize)
    },
    watch:{
      scrollY(){
        this.headerFix=this.scrollY>50?true:false
      }
    }
  }
</script>
